import type { OidcUser, UserIdentity } from '@/types';

const getStringClaim = (claim: unknown): string | undefined => {
  if (typeof claim === 'string' && claim.trim().length > 0) {
    return claim;
  }

  return undefined;
};

const getUserIdentity = (auth_user: OidcUser): UserIdentity => {
  const preferred_username = getStringClaim(auth_user.profile?.preferred_username);
  const name = getStringClaim(auth_user.profile?.name) || preferred_username || '';

  return {
    user_id: preferred_username || auth_user.profile?.sub || '',
    name,
  };
};

export default getUserIdentity;
